import { hydrateFeeds } from '../app/ui-feeds.js';

export async function loadClientProfiles() {
  try {
    const response = await fetch('/api/profiles');
    if (!response.ok) {
      throw new Error(`Failed to load profiles: ${response.status}`);
    }
    const profiles = await response.json();
    return profiles;
  } catch (err) {
    console.error('[loadClientProfiles] Error:', err);
    return [];
  }
}


export async function createProfiles(pendingProfiles) {

  try {
    const res = await fetch('/api/profiles/batch-create', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ profiles: pendingProfiles })
    });

    if (!res.ok) throw new Error(await res.text());
      // {"message": "Profiles created successfully.", "profile_ids": profile_ids}
      const result = await res.json();
      console.log(`✅ createProfiles result: ${res.message}, profile_ids: ${result.profile_ids}`);
      return { success: true, created: result.profile_ids };
  } catch (err) {
      console.error('Submission error:', err);
      alert('Failed to submit profiles.');
      const result = await res.json();
      return { success: false, error: result?.message || 'Unknown error' };
  }
}

export async function updateClientProfiles(pendingProfiles) {
  try {
    const response = await fetch('/api/profiles/batch-update', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'include', // Include cookies if needed
      body: JSON.stringify({ profiles: pendingProfiles })
    });

    if (!response.ok) {
      throw new Error(response.status);
    }
    const result = await response.json();
    console.log(`✅ updateProfiles result: ${response.message}, profile_ids: ${result.profile_ids}`);
    return { success: true, updated: result.profile_ids };
  } catch (err) {
    console.error('Submission error:', err);
    return { success: false, error: err?.message || 'Unknown error' };
  }
}

export async function updateProfile(currentProfile) {
  if (!currentProfile || !currentProfile.id) {
    console.error('[UpdateProfile] Missing profile data');
    return;
  }
  try {
    const res = await fetch(`/api/profiles/${currentProfile.id}`, {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(currentProfile)
    });
    if (!res.ok) throw new Error(await res.text());
    const result = await res.json();
    console.log(`[UpdateProfile] Successfully updated profile ${currentProfile.id}`);
    return result;
  } catch (err) {
    console.error('[UpdateProfile] Failed to update profile:', err);
    throw err; // Re-throw to handle in UI
  }
}

export async function fetchFeeds(profileId) {
  const res = await fetch(`/api/profiles/${profileId}/feeds?days=1`);
  if (!res.ok) throw new Error(await res.text());
  return await res.json();
}

// Optional: fetch food references for app display
export async function fetchFoods(profileId) {
  const res = await fetch(`/api/profiles/${profileId}/foods`);
  if (!res.ok) throw new Error(await res.text());
  return await res.json();
}

export async function addFeedRecord(profileId, foodId, amount, nick) {
  if (!profileId || !foodId || !amount || !nick) {
    console.error('[Feed] Missing required parameters');
    return;
  }
  const now = new Date();
  const isoString = now.toISOString();
  const payload = { 
    food_id: Number(foodId),
    amount: parseFloat(amount),
    nick: nick,
    created_at: isoString, // Send as ISO string, more reliable
  };
  try {
    const res = await fetch(`/api/profiles/${profileId}/feeds`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload)
    });
    if (!res.ok) throw new Error(await res.text());
    const result = await res.json();
    const addFeedRecordId = result.record_id;
    await hydrateFeeds(profileId, addFeedRecordId); // reload feeds and summary
    console.log(`[Feed] Successfully added record ${addFeedRecordId} for profile ${profileId}`);
  } catch (err) {
    console.error('[Feed] Failed to add record:', err);
  }
}

export async function deleteFeed(profileId, feedId) {
  if (!feedId || !profileId) {
    console.error('[Feed] Missing required parameters');
    return;
  }
  try {
    const res = await fetch(`/api/profiles/${profileId}/feeds/${feedId}`, {
      method: 'DELETE',
      headers: { 'Content-Type': 'application/json' }
    });
    if (!res.ok) throw new Error(await res.text());
    await hydrateFeeds(profileId); // reload feeds and summary
    console.log(`[Feed] Successfully deleted record ${feedId} for profile ${profileId}`);
  } catch (err) {
    console.error('[Feed] Failed to delete record:', err);
  }
}